import netWorkController from "@/http/netWorkController";
import toastUtils from "@/utils/toastUtils";
import dateUtils from "@/utils/dateUtils";
import tipsDialog from "@/views/TipsDialog";
import createUserDialog from "@/views/CreateUserDialog";
import editPassWordDialog from "@/views/EditPassWordDialog";

export default {
    name: "UserInfoPage",
    components: {tipsDialog, createUserDialog, editPassWordDialog},
    data() {
        return {
            dialogVisible: false,
            addUserDialogVisible: false,
            editDialogVisible: false,
            dialogType: 1,
            ///当前账户信息
            currentUserInfo: {},
            requestForm: {
                ///当前页数
                pageNum: 1,
                ///一页总数
                pageSize: 10,
                ///总条数
                total: 0,
            },
            parentUser: [],
            childList: [],
            selectUser: {},
            editUser: {}
        }
    },
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.currentUserInfo = JSON.parse(userInfoStr)
            this.parentUser.push(this.currentUserInfo)
            this.requestForm.id = this.currentUserInfo.id;
            this.requestForm.accessToken = this.currentUserInfo.accessToken
            this.getChildList();
        }
    },
    methods: {
        getChildList() {
            netWorkController.getChildUserList(this.requestForm, (result) => {
                if (result.status === 200) {
                    this.childList = result.data.list
                    this.requestForm.pageNum = result.data.pageNum
                    this.requestForm.pageSize = result.data.pageSize
                    this.requestForm.total = result.data.total
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        showTipsDialog(user) {
            if (user) {
                this.selectUser = user;
                this.selectUser.parentId = this.currentUserInfo.id
                this.selectUser.accessToken = this.currentUserInfo.accessToken
                this.dialogVisible = true;
            }
        },
        tipsDialogClick(dialogTitle, value) {
            this.dialogVisible = false;
            if (value) {
                this.deleteChildUser()
            }
        },
        deleteChildUser() {
            netWorkController.deleteUser(this.selectUser, (result) => {
                if (result.status === 200) {
                    toastUtils.success(this, result.msg)
                    this.getChildList();
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
        showCreatUserDialog(user, type) {
            this.dialogType = type;
            if (user) {
                this.editUser = JSON.parse(JSON.stringify(user));
            }
            this.addUserDialogVisible = true;
        },
        creatUserClick(value, dialogType) {
            this.addUserDialogVisible = false;
            if (value) {
                if (dialogType !== 3) {
                    value.parentId = this.currentUserInfo.id;
                    value.parentAccessToken = this.currentUserInfo.accessToken;
                }
                switch (dialogType) {
                    case 1:
                        netWorkController.addChildUser(value, (result) => {
                            if (result.status === 200) {
                                toastUtils.success(this, result.msg)
                                this.getChildList();
                            } else {
                                toastUtils.warning(this, result.msg)
                            }
                        })
                        break
                    case 2:
                        netWorkController.updateChildUser(value, (result) => {
                            if (result.status === 200) {
                                toastUtils.success(this, result.msg)
                                this.getChildList();
                            } else {
                                toastUtils.warning(this, result.msg)
                            }
                        })
                        break
                    case 3:
                        netWorkController.updateUser(value, (result) => {
                            if (result.status === 200) {
                                toastUtils.success(this, result.msg)
                                this.parentUser = []
                                this.parentUser.push(result.data)
                                this.currentUserInfo = result.data;
                                //存储对象，转成Json存入
                                window.localStorage.setItem("userInfo", JSON.stringify(result.data))
                            } else {
                                toastUtils.warning(this, result.msg)
                            }
                        })
                        break
                }
            }
        },
        showEditUserClick(user) {
            if (user) {
                this.editUser = JSON.parse(JSON.stringify(user));
            }
            this.editDialogVisible = true;
        },
        editUserClick(value) {
            this.editDialogVisible = false;
            if (value) {
                netWorkController.editPassword(value, (result) => {
                    if (result.status === 200) {
                        toastUtils.success(this, result.msg)
                        this.parentUser = []
                        this.parentUser.push(result.data)
                        this.currentUserInfo = result.data;
                        //存储对象，转成Json存入
                        window.localStorage.setItem("userInfo", JSON.stringify(result.data))
                    } else {
                        toastUtils.warning(this, result.msg)
                    }
                })
            }
        },
        formatDate(row, column, cellValue) {
            return dateUtils.timestampToDate(cellValue);
        },
        handleSizeChange(value) {
            if (value) {
                this.requestForm.pageSize = value
                this.getChildList()
            }
        },
        handleCurrentChange(value) {
            if (value) {
                this.requestForm.pageNum = value;
                this.getChildList()
            }
        },
    }
}